export enum ImageDestinationEnum {
	Users = 'users',
	Events = 'events',
	Chats = 'chats',
	FeaturedImages = 'featured_images',
	Lobby = 'lobby',
	Newsfeed = 'newsfeed',
	Courses = 'courses',
}

export const ImageDestinationArray = Object.values(ImageDestinationEnum);
